<script>
    import {fade} from 'svelte/transition';
    import {navigateTo} from 'svelte-router-spa';
    import {PRConnect} from "@projectroom/ui-lib";
	import { accessToken } from './store/auth-store';
	import { Card, Button, Dialog } from '../lib/ui';

    let password;
    let passwordCheck;
    let validMessage = false;
    let refValidMessag;
    let popupSuccess = false;

    // shadcn 인풋 공용 클래스
    const inputCls = "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-opacity-50";

    const clickResetPasswordSubmit = () => {

        if (!checkValidPassword() || !checkEqualPassword()) {
            return;
        }
        const resetToken = window.location.search.substr(1, 32);
        PRConnect.send("/api/Auth/updatePassword", {password, resetToken}, data => {
            if(data.result.status === "success"){
				accessToken.set(data.result.accessToken);
                popupSuccess = true;
            }
        });
    }

    const validPassword = () => {
        //특수문자 / 문자 / 숫자 포함 형태의 8자 이상
        const regex = /^.*(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=<>]).*$/;
        return password.match(regex) == null;
    }

    const checkValidPassword = () => {
        if (!validPassword()) {
            validMessage = false;
            return true;
        }
        changeValidMessage("특수문자, 문자, 숫자 포함 형태의 8자 이상이어야 합니다.");
        return false;
    }

    const checkEqualPassword = () => {
        if (password === passwordCheck) {
            validMessage = false;
            return true;
        }
        changeValidMessage("비밀번호가 일치하지 않습니다.");
        return false;
    }

    const changeValidMessage = (message) => {
        refValidMessag.innerText = message;
        validMessage = true;
    }
</script>

<div class="tw-flex tw-min-h-screen tw-justify-center tw-bg-background tw-px-4 tw-pb-20 tw-pt-24 tw-font-sans tw-text-foreground sm:tw-pt-28" in:fade>
    <div class="tw-w-full tw-max-w-[420px]">
        <Card class="tw-p-8 sm:tw-p-10">
            <h1 class="tw-mb-1 tw-text-center tw-text-2xl tw-font-bold tw-text-foreground">비밀번호 재설정</h1>
            <p class="tw-mt-2 tw-text-center tw-text-sm tw-text-muted-foreground">새로운 비밀번호를 입력해 주세요.</p>

            <div bind:this={refValidMessag} class="tw-mt-4 tw-rounded-md tw-bg-destructive/10 tw-px-3 tw-py-2 tw-text-center tw-text-sm tw-font-medium tw-text-destructive" class:tw-hidden={!validMessage}></div>

            <form class="tw-mt-6 tw-space-y-4" on:submit|preventDefault={clickResetPasswordSubmit}>
                <div>
                    <label for="reset-pw" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">비밀번호</label>
                    <input id="reset-pw" type="password" maxlength="256" placeholder="새 비밀번호(특수문자, 문자, 숫자 포함 형태의 8자 이상)" bind:value={password} on:keyup={checkValidPassword} class={inputCls} />
                </div>
                <div>
                    <label for="reset-pw2" class="tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground">비밀번호 확인</label>
                    <input id="reset-pw2" type="password" placeholder="비밀번호 확인" bind:value={passwordCheck} on:keyup={checkEqualPassword} class={inputCls} />
                </div>

                <Button type="submit" size="lg" class="tw-w-full">변경하기</Button>
            </form>

            <p class="tw-mt-6 tw-text-center tw-text-sm tw-text-muted-foreground">
                <button type="button" class="tw-cursor-pointer tw-bg-transparent tw-font-semibold tw-text-primary hover:tw-underline" on:click={()=>navigateTo("/login")}>로그인</button> 화면으로 돌아가기
            </p>
        </Card>
    </div>
</div>

<Dialog open={popupSuccess} title="비밀번호가 변경되었습니다." on:close={()=> navigateTo("/main")}>
    <p class="tw-m-0 tw-text-sm tw-text-muted-foreground">변경된 비밀번호로 로그인할 수 있어요.</p>
    <Button slot="footer" on:click={()=> navigateTo("/main")}>메인으로</Button>
</Dialog>
